import { Col, Row, Spin } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { Booking } from "../../../../../types/bookings";
import { formatDateByType, formatPhoneNumber } from "../../../../libs/utils";
import { getKycLabel } from "../utils";
import { Item } from "../view";

type TenantDetailsProps = {
  kycDetails?: Record<string, unknown>[];
};

export const TenantDetails = (props: TenantDetailsProps) => {
  const { kycDetails } = props;

  const bookingState = useSelector((state: any) => state.newBooking);
  const { propertyDetails, tenantDetails, isSignatory, signatoryUser } = bookingState?.bookingDetails as Booking;

  const isCommercialCompanyTenantType = tenantDetails?.tenantIdentityType === "company";
  const isCommercialIndividualTenantType = tenantDetails?.tenantIdentityType === "individual";

  const usagesType = propertyDetails?.usagesType?.toLowerCase();
  const isCommercialUsage = usagesType === "commercial";
  const isResidentialUsage = usagesType === "residential";

  const isBooking = bookingState?.bookingDetails && Object.keys(bookingState?.bookingDetails).length > 0;
  const valueStyle = { textTransform: "capitalize" };

  const navigateToTenantDetail = () => {
    try {
      window.open(`/tenants-detail/${bookingState?.bookingDetails?.tenantId}`, "_blank");
    } catch (error) {
      console.log(error);
    }
  };

  const getNameLabel = () => {
    if (isCommercialUsage) {
      if (isCommercialCompanyTenantType) return "Company Name";
      if (isCommercialIndividualTenantType) return "Tenant Name";
    }
    if (isResidentialUsage) return "Tenant Name";
    return "Name";
  };

  return (
    <Col span={24} className="view-booking">
      {!isBooking && (
        <Row gutter={24} className="loading">
          <Spin size="large" />
        </Row>
      )}

      {isBooking && (
        <>
          <Row gutter={24} className="bd-item">
            <Item
              label={getNameLabel()}
              value={tenantDetails?.tenantNameEN}
              checkTenantInfo={navigateToTenantDetail}
              tenantLink
            />
            {isResidentialUsage && <Item label="Tenant Name Arabic" value={tenantDetails?.tenantNameAR} />}
            <Item label="Email Address" value={tenantDetails?.email} />

            {isCommercialUsage ? (
              <>
                {isCommercialCompanyTenantType && (
                  <Item label="Phone number" value={formatPhoneNumber(tenantDetails?.companyPhone, tenantDetails?.countryCode)} />
                )}
                {isCommercialIndividualTenantType && (
                  <>
                    <Item label="Mobile Number" value={formatPhoneNumber(tenantDetails?.mobileNumber, tenantDetails?.countryCode)} />
                    <Item
                      label="Designation"
                      valueStyle={valueStyle}
                      value={tenantDetails?.designation || tenantDetails?.designationAsPerVisa}
                    />
                    <Item label="Company" valueStyle={valueStyle} value={tenantDetails?.company} />
                  </>
                )}
              </>
            ) : (
              <>
                <Item label="Mobile Number" value={formatPhoneNumber(tenantDetails?.mobileNumber, tenantDetails?.countryCode)} />
                {tenantDetails?.workPhone && (
                  <Item label="Work Phone" value={tenantDetails?.workPhone} />
                )}
                <Item label="Nationality" valueStyle={valueStyle} value={tenantDetails?.nationality} />
                <Item label="Marital Status" valueStyle={valueStyle} value={tenantDetails?.maritalStatus} />
              </>
            )}

            <Item valueStyle={valueStyle} label="Is the tenant the authorized signatory?" value={isSignatory} />
          </Row>

          {isSignatory === "no" && signatoryUser && (
            <Row gutter={24} className="bd-item">
              <Item label="Signatory Email" value={signatoryUser?.email} />
              <Item label="Signatory Name" value={signatoryUser?.name} />
              {isResidentialUsage && <Item label="Signatory Arabic Name" value={signatoryUser?.arabicName} />}
              <Item 
                label="Signatory Mobile Number" 
                value={formatPhoneNumber(
                  String(signatoryUser?.mobile || ""), 
                  typeof signatoryUser?.countryCode === "string" ? signatoryUser.countryCode : undefined
                )} 
              />
              <Item label="Designation" value={signatoryUser?.designation} />
              <Item label="Company" value={signatoryUser?.company} />
            </Row>
          )}

          {kycDetails?.length > 0 && Object.keys(bookingState?.bookingDetails?.kycDetails || {})?.length > 0 && (
            <Row gutter={24} className="bd-item">
              {kycDetails?.length > 0 &&
                Object.keys(bookingState?.bookingDetails?.kycDetails)?.map((key) => {
                  const value = bookingState?.bookingDetails?.kycDetails?.[key];
                  if (!value) return null;

                  const isDateField = key.toLowerCase().includes("date");
                  return (
                    <Item
                      key={key}
                      label={getKycLabel(key, kycDetails)}
                      value={isDateField ? formatDateByType(value) : value}
                    />
                  );
                })}
            </Row>
          )}
        </>
      )}
    </Col>
  );
};
